import { AssetDto } from "@/core/api/generated/v1";

import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "../components/BaseEntityAutocompleteOrCreate";
import AssetAutocomplete, { AssetAutocompleteProps } from "./AssetAutocomplete";
import AssetCreateUpdate, { AssetCreateUpdateProps } from "./AssetCreateUpdate";
import AssetCreateUpdateModal from "./AssetCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  AssetDto,
  AssetCreateUpdateProps["defaultValues"],
  AssetAutocompleteProps,
  AssetCreateUpdateProps
>;

export default function AssetAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      AssetDto,
      AssetCreateUpdateProps["defaultValues"],
      AssetAutocompleteProps,
      AssetCreateUpdateProps
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <AssetAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new asset "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              name: newOption?.inputValue || params.defaultValues?.name || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <AssetCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <AssetCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
